import { render, staticRenderFns } from "./indexLiveStreamList.vue?vue&type=template&id=095bdf94&scoped=true&"
import script from "./indexLiveStreamList.vue?vue&type=script&lang=js&"
export * from "./indexLiveStreamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095bdf94",
  null
  
)

export default component.exports